import { ChangeEvent, FunctionComponent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal, saveModal, setCategoryValues } from "../../store/modal";
import { Button } from "../button";
import Modal from "react-modal";
import { Input } from "../input";
import { TextArea } from "../textarea";
import { getLocalizedField, setLocalizedFieldOnObject } from "../../lib/util";

const modalStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
    },
};

export const CategoryModal: FunctionComponent = (): JSX.Element => {
    const open = useSelector(s => s.modal.visible === "category");
    const categories = useSelector(s => s.app.categories);
    const formValues = useSelector(s => s.modal.categoryValues || {});
    const lang = useSelector(s => s.app.lang);
    const transMode = useSelector(s => s.app.transMode);
    const dispatch = useDispatch();

    const handleSave = () => {
        dispatch(saveModal());
    };

    const handleClose = () => {
        dispatch(closeModal());
    };

    const handleTitleChange = (val: string) => {
        dispatch(setCategoryValues(setLocalizedFieldOnObject(formValues, { title: val }, lang, transMode)));
    };

    const handleDescriptionChange = (val: string) => {
        dispatch(setCategoryValues(setLocalizedFieldOnObject(formValues, { description: val }, lang, transMode)));
    };

    const handleParentChange = (e: ChangeEvent<HTMLSelectElement>) => {
        dispatch(
            setCategoryValues({
                ...formValues,
                parentId: e.currentTarget.value,
            }),
        );
    };

    return (
        <Modal isOpen={open} style={modalStyles}>
            <div className="text-xl mb-4 font-bold">Kategorie erstellen</div>
            <div className="grid gap-2">
                <Input
                    value={getLocalizedField(formValues, "title", lang, transMode) || ""}
                    placeholder={formValues.title || "Titel..."}
                    onChange={val => handleTitleChange(val)}
                />
                <TextArea
                    value={getLocalizedField(formValues, "description", lang, transMode) || ""}
                    placeholder={formValues.description || "Beschreibung..."}
                    onChange={val => handleDescriptionChange(val)}
                />
                <div>
                    <div>Überkategorie</div>
                    <select
                        value={formValues.parentId}
                        className="appearance-none bg-dark-lighter outlilne-none p-2 rounded-lg"
                        onChange={handleParentChange}
                    >
                        <option value="">-- Keine --</option>
                        {categories.map(cat => (
                            <option key={cat.id} value={cat.id}>
                                {cat.title}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="grid grid-cols-2 gap-2 mt-4">
                <Button label="Abbrechen" onClick={handleClose} />
                <Button label="Speichern" onClick={handleSave} />
            </div>
        </Modal>
    );
};
